<script setup lang="ts">
import { Ref, ref, watch } from 'vue';
import type { CSwitchOption } from '.';

const props = defineProps<{
    value?: string | number;
    options: CSwitchOption[];
}>();

const emit = defineEmits<{
    (e: 'input', value: string | number): void;
}>();

const _model: Ref<number | string> = ref(props.value || props.options[0].value);

const onOptionSelected = (option: CSwitchOption) => {
    if (_model.value == option.value) return;
    _model.value = option.value;
    emit('input', option.value);
};

watch(
    () => props.value,
    (value) => {
        if (value && value != _model.value) {
            _model.value = value;
        }
    }
);
</script>

<template>
    <div class="c-switch-wrapper">
        <span
            v-for="option of options"
            :key="option.value"
            class="option"
            role="radio"
            :class="{ selected: _model == option.value, disabled: option.disabled }"
            @click="onOptionSelected(option)"
        >
            {{ option.label }}
        </span>
    </div>
</template>

<style scoped lang="scss">
@import 'styles/utilities/functions';

.c-switch-wrapper {
    display: flex;
    align-items: center;
    gap: 2px;
    border: 1px solid get-color('purple-dark');
    padding: 2px;
    border-radius: 50rem;
    color: get-color('purple-dark');
    cursor: pointer;

    .option {
        border-radius: 50rem;
        padding: 0.5rem 1rem;
        &:not(.selected):hover {
            background-color: get-color('gray-100');
        }
        &.selected {
            background-color: get-color('purple-dark');
            color: white;
        }
        &.disabled {
            pointer-events: none;
        }
    }
}
</style>
